<!-- 由 suu 创建于 2021-08-19 星期四 -->
<template>
  <div
    class="reservations"
    :style="{
      paddingTop: height + 'px'
    }"
    v-if="evaluate"
  >
    <!-- v-if="isApp" -->
    <!-- 导航栏 -->
    <div
      class="reservations-bar"
      :style="{
        height: height + 'px',
        paddingTop: statusBarHeight + 'px'
      }"
    >
      <div class="bar-back" @click="$http.appBack()"
        ><i class="iconfont icon-you"></i
      ></div>
      <img
        src="https://cdnvue.gymcity.com.cn/uploads/pub-white-logo-jmjs"
        class="bar-logo"
        alt
      />
    </div>
    <!-- 背景 -->
    <div class="new-top-bg"> </div>
    <!-- 成功标题 -->
    <div class="new-top-top">
      <div class="top-img-box">
        <img
          class="top-img"
          src="https://cdnvue.gymcity.com.cn/uploads/ykcg-zysx-icon-success"
        />
        <div class="top-text">预约成功!</div>
      </div>
    </div>
    <!-- 权限通知 -->
    <div class="new-complete-bar" v-if="showFloatBar">
      <div>开启推送通知，及时查收课前提醒</div>
      <div class="bar-right user-btn" @click="handleClickBar">去开启</div>
    </div>
    <div
      class="new-top-content"
      :class="{ 'new-top-content-grade': showMemberGrade }"
    >
      <img
        class="rs-top-grade"
        v-if="showMemberGrade"
        @click="handleClickGrade"
        :src="`https://cdnvue.gymcity.com.cn/uploads/mgs-yk-qy-v${userGrade}`"
        alt=""
      />
      <div class="rs-top-item">
        <div class="item-title">预约教练</div>
        <div class="item-content">
          <div class="item-text">{{ evaluate.name }}</div>
          <div
            class="item-tips"
            v-if="evaluate.beforenum && evaluate.beforenum > 0"
            >已约{{ evaluate.beforenum }}次</div
          >
        </div>
      </div>
      <div class="rs-top-item">
        <div class="item-title">预约时间</div>
        <div class="item-content">
          <div class="item-text">{{ getDateText() }}</div>
          <div class="item-tips">距离上课时间还有{{ getTimeText() }}</div>
        </div>
      </div>
      <div class="rs-top-item">
        <div class="item-title">预约门店</div>
        <div class="item-content" @click="handleOpenMap">
          <div class="item-text"
            >{{ evaluate.shop_name }}
            <i class="iconfont icon-daohang location-icon"></i>
            <!-- <i class="iconfont icon-dingwei-shixin location-icon"></i> -->
          </div>
          <div class="item-tips" v-if="evaluate.distanceP || evaluate.distance">
            上课地点{{ evaluate.distanceP || evaluate.distance }}
          </div>
        </div>
      </div>
      <div class="rs-bottom">
        <div class="rs-bottom-item" @click="handleContactCoach">
          <i class="iconfont icon-chat item-btn-icon"></i>
          <span>联系教练</span>
        </div>
        <div class="rs-bottom-item" @click="handleViewCourseDetail">
          <i class="iconfont icon-plan item-btn-icon"></i>
          <span>查看训练计划</span>
        </div>
      </div>
    </div>
    <!-- 注意事项 -->
    <img
      src="https://cdnvue.gymcity.com.cn/uploads/ykcg-zysx-bg-250613?v=2"
      alt=""
      class="atend-img"
    />
    <!-- 底部按钮 -->
    <div class="rs-btn-box">
      <div class="rs-btn-back user-btn" v-if="isApp" @click="handleBackApp"
        >返回首页</div
      >
      <div class="rs-btn user-btn" @click="handleContinue">继续约课</div>
    </div>
    <!-- 打卡活动弹窗 -->
    <ReservationsActPop
      v-if="showgzhDakaPop"
      @boxClose="handleActPopClose"
    ></ReservationsActPop>
    <!-- 节气海报 -->
    <solarTermsPoster
      v-if="showSolarTermsPop"
      @over="handleSolarTermsComplete"
      @close="handlePopClose('showSolarTermsPop')"
    ></solarTermsPoster>
    <!-- 推荐教练弹窗 -->
    <ReservationsRecommendCoachPop
      :visible.sync="showRecommendCoachIPop"
      :coach-info="recommendCoachInfo"
      @close="handleRecommendCoachPopClose"
    />
    <!-- 店长提示弹窗 -->
    <ReservationsShopTipsPop
      :visible.sync="showShopTipsPop"
      :shop-info="shopTipsInfo"
      @close="handleShopTipsPopClose"
      @openGuide="handleShopTipsOpenGuide"
      @linkShop="handleLinkShop"
    />
  </div>
</template>

<script>
import ReservationsActPop from './ponents/ReservationsActPop.vue'
import ReservationsRecommendCoachPop from './ponents/ReservationsRecommendCoachPop.vue'
import ReservationsShopTipsPop from './ponents/ReservationsShopTipsPop.vue'
import solarTermsPoster from '@/components/solar-terms-poster.vue'
import { mapState } from 'vuex'

// ==================== 常量定义 ====================
// 日历相关常量
const CALENDAR_CONFIG = {
  // 新版本日历配置 (version >= 270)
  NEW_VERSION: {
    calendarAccountName: 'iCloud',
    calendarId: 'E8774700-375B-4596-81B5-72281A991ACA', // 写死 同获取上课提醒列表
    calendarName: '健萌上课提醒',
    eventTitle: '健萌上课提醒'
  },
  // 旧版本日历配置
  OLD_VERSION: {
    calendarAccountName: 'betterWE星球',
    eventTitle: '健萌上课提醒'
  },
  // 通用配置
  COMMON: {
    allDay: 0,
    availability: 2,
    recurrenceInterval: 1,
    recurrenceMethod: 0,
    remindersTimeMinutes: 60
  },
  // 版本号阈值
  VERSION_THRESHOLD: 270
}

export default {
  name: 'reservations',

  components: {
    ReservationsActPop,
    ReservationsRecommendCoachPop,
    ReservationsShopTipsPop,
    solarTermsPoster
  },

  data() {
    return {
      statusBarHeight: 0, // 状态栏高度
      height: 0, // 状态栏+导航栏高度
      evaluate: null, // 预约课程信息
      showgzhDakaPop: false, // 公众号打卡活动弹窗显示状态
      showFloatBar: false, // 显示权限告知浮窗
      showSolarTermsPop: false, // 节气弹窗
      showPoping: false, // 是否有弹窗正在显示
      recommendCoachInfo: null, // 推荐教练信息
      showRecommendCoachIPop: false, // 显示推荐教练弹窗
      showShopTipsPop: false, // 店长提示弹窗显示状态
      shopTipsInfo: null // 店长提示信息
    }
  },

  computed: {
    ...mapState({
      solarTerms: (state) => state.solarTerms,
      userMemberState: (state) => state.user.user.member_state,
      userGrade: (state) => state.user.user.user_grade,
      user: (state) => state.user.user
    }),
    // 会员等级弹窗显示状态
    showMemberGrade() {
      return this.userGrade && this.userGrade > 1
    },
    /**
     * 判断是否在App环境中
     * @returns {boolean}
     */
    isApp() {
      // return true // 测试
      return this.$betterwe.isApp()
    }
  },

  created() {
    // 获取导航栏高度
    this.getNavContentHeight()
    // 初始化数据
    this.initializeData()
  },

  methods: {
    // 跳转等级中心
    handleClickGrade() {
      this.$http._toVueH5Url(
        `member-grade?grade=${this.userGrade}`,
        'push',
        '会员等级'
      )
    },
    // ==================== 初始化相关方法 ====================

    /**
     * 初始化页面数据
     * 包括: 解析路由参数、添加日历日程、检查节气海报、获取推荐教练信息
     */
    initializeData() {
      // 从路由参数中解析预约信息
      this.evaluate = JSON.parse(this.$route.query.evaluate)
      console.log('this.evaluate', this.evaluate)
      // this.checkGzhDakaPop()

      // 在App环境中添加日历日程
      if (this.$betterwe.isApp()) {
        this.addGymCourseAppointmentComplete()
      }

      // 优先判断显示APP日历权限弹窗
      // setTimeout(() => {
      // 检查25 节气海报
      this.checkSolarTermsPoster()
      // 店长提示信息
      this.getShopTipsInfo()
      // }, 500)
    },

    // 获取是否首商第一次约当前教练或当前门店课程 判断是否显示店长提示弹窗
    async getShopTipsInfo() {
      const res = await this.$http.get('member/AppointData?a=orderedInfo', {
        cid: this.evaluate.courseid
      })
      // 教练第一次约课并且首商 或者 门店第一次约课
      if (
        res.data.code === 200 &&
        ((res.data.data.coach_ordered_count == 1 &&
          res.data.data.fbu_status == 1) ||
          res.data.data.shop_ordered_count == 1)
      ) {
        // 如果是首商第一次约当前教练或当前门店课程 则显示店长提示弹窗
        this.shopTipsInfo = res.data.data
        if (this.showPop('showShopTipsPop')) {
          this.$http.get('member/index?a=shareLogPush', {
            from: `${
              this.shopTipsInfo.shop_ordered_count == 1
                ? '首次跨馆约课店长卡片'
                : '首商首次约课店长卡片'
            }-曝光`,
            from_id: 260706234
          })
        }
      } else {
        // 如果不弹店长提示则获取推荐教练信息
        this.getRecommendCoachInfo()
      }
    },

    // 点击店长提示弹窗中的门店店店指引
    handleShopTipsOpenGuide(shopId) {
      this.$http.get('member/index?a=shareLogPush', {
        from: `${
          this.shopTipsInfo.shop_ordered_count == 1
            ? '首次跨馆约课店长卡片'
            : '首商首次约课店长卡片'
        }-点击到店指引`,
        from_id: 260706234
      })
      this.$http._toVueH5Url(
        `shop-route-guide?shopid=${shopId}`,
        'push',
        '到店指引'
      )
    },

    // 点击店长提示弹窗中的门店微信工作
    handleLinkShop() {
      this.$http.get('member/index?a=shareLogPush', {
        from: `${
          this.shopTipsInfo.shop_ordered_count == 1
            ? '首次跨馆约课店长卡片'
            : '首商首次约课店长卡片'
        }-点击联系店长`,
        from_id: 260706234
      })
      this.$router.push(
        '/coach-wxwork-card?cType=shop_manager&cid=' +
          this.shopTipsInfo.main_manager.id
      )
    },
    /**
     * 关闭店长提示弹窗
     */
    handleShopTipsPopClose() {
      this.showShopTipsPop = false
      this.showPoping = false
    },
    /**
     * 获取导航栏高度
     * App环境从原生获取，非App环境使用默认值
     */
    async getNavContentHeight() {
      if (this.isApp) {
        let res = await this.$betterwe.getAppBarHeight().catch(() => {})
        if (res) {
          this.statusBarHeight = res.statusBarHeight
          this.height = this.statusBarHeight + res.toolsBarHeight
        }
      } else {
        // 非App环境使用默认值
        this.statusBarHeight = 40
        this.height = this.statusBarHeight + 28
      }
    },

    // ==================== 时间格式化相关方法 ====================

    /**
     * 获取预约时间文本
     * 格式: YYYY.MM.DD HH:mm-HH:mm
     * @returns {string}
     */
    getDateText() {
      return (
        this.evaluate.s_time.slice(0, 16).replace(/-/g, '.') +
        '-' +
        this.evaluate.e_time.slice(11, 16)
      )
    },

    /**
     * 获取距离上课时间的文本
     * 格式: X天X小时X分钟
     * @param {number} time - 时间戳(可选，未使用)
     * @returns {string}
     */
    getTimeText(time) {
      // 计算时间差(毫秒)
      const date3 = Math.abs(
        new Date(this.evaluate.s_time.replace(/-/g, '/')).getTime() - Date.now()
      )

      // 计算天数
      const daysValue = Math.floor(date3 / (24 * 3600 * 1000))
      let days = daysValue > 0 ? daysValue + '天' : ''

      // 计算小时数
      let leave1 = date3 % (24 * 3600 * 1000)
      const hoursValue = Math.floor(leave1 / (3600 * 1000))
      let hours = hoursValue + '小时'

      // 计算分钟数
      let leave2 = leave1 % (3600 * 1000)
      const minutesValue = Math.floor(leave2 / (60 * 1000))
      let minutes = minutesValue + '分钟'

      return `${days}${hours}${minutes}`
    },

    /**
     * 格式化时间用于日历名称
     * @param {string} sTime - 开始时间
     * @param {string} eTime - 结束时间
     * @returns {string}
     */
    _formatTime(sTime, eTime) {
      const allDay = sTime.split(' ')[0]
      const [, month, day] = allDay.split('-')
      const timeRange = `${sTime.slice(-8, -3)}-${eTime.slice(-8, -3)}`
      return `课程时间：${Number(month)}月${Number(day)}日 ${timeRange}`
    },

    // ==================== 弹窗相关方法 ====================

    /**
     * 弹窗通用处理方法
     * 判断是否显示过弹窗，优先显示APP日历权限弹窗
     * @param {string} val - 弹窗状态属性名
     * @returns {boolean} 是否成功显示弹窗
     */
    showPop(val) {
      if (!this.showPoping) {
        this[val] = true
        this.showPoping = true
        return true
      }
      return false
    },

    /**
     * 关闭弹窗
     * @param {string} val - 弹窗状态属性名
     */
    handlePopClose(val) {
      this[val] = false
      this.showPoping = false
    },

    /**
     * 关闭活动弹窗
     */
    handleActPopClose() {
      this.showgzhDakaPop = false
    },

    // ==================== 节气海报相关方法 ====================

    /**
     * 25 节气海报 是否静默生成海报图片
     * 检查用户会员状态、时间有效性、弹窗显示条件
     */
    checkSolarTermsPoster() {
      // 仅会员用户显示
      if (this.userMemberState * 1 !== 1) return false

      const now = new Date()
      const { starTime, endTime, curTitle, popTime } = this.solarTerms

      // 检查时间是否有效
      if (!this.isSolarTermsTimeValid(now, starTime, endTime)) return false

      // 检查是否应该显示弹窗
      const lastPopTime = localStorage.getItem(`showSolarTermsPop${curTitle}`)
      const popCount = Number(
        localStorage.getItem(`showSolarTermsPopTime${curTitle}`) || 0
      )

      if (this.shouldShowSolarTermsPop(lastPopTime, popCount, now, popTime)) {
        this.showPop('showSolarTermsPop')
      }
    },

    /**
     * 25 节气海报 时间是否有效
     * @param {Date} now - 当前时间
     * @param {string} starTime - 开始时间
     * @param {string} endTime - 结束时间
     * @returns {boolean}
     */
    isSolarTermsTimeValid(now, starTime, endTime) {
      return (
        window.localStorage &&
        (now >= new Date(starTime) || this.$http.getEnv() != 'Pro') &&
        now < new Date(endTime)
      )
    },

    /**
     * 25 节气海报 是否显示弹窗
     * @param {string|null} lastPopTime - 上次弹窗时间
     * @param {number} popCount - 已弹窗次数
     * @param {Date} now - 当前时间
     * @param {number} maxPops - 最大弹窗次数
     * @returns {boolean}
     */
    shouldShowSolarTermsPop(lastPopTime, popCount, now, maxPops) {
      return (
        !lastPopTime ||
        (popCount < maxPops &&
          new Date(now).toDateString() !==
            new Date(lastPopTime * 1).toDateString())
      )
    },

    /**
     * 25 节气海报生成后确认弹窗 记录数据
     */
    handleSolarTermsComplete() {
      const { curTitle } = this.solarTerms
      const now = new Date()
      const popCount = Number(
        localStorage.getItem(`showSolarTermsPopTime${curTitle}`) || 0
      )

      this.showPoping = true
      this.logSolarTermsShare(curTitle)
      this.updateSolarTermsStorage(curTitle, now, popCount)
    },

    /**
     * 25 节气海报 上报弹窗曝光
     * @param {string} curTitle - 当前节气标题
     */
    logSolarTermsShare(curTitle) {
      this.$http.get('member/index?a=shareLogPush', {
        from: `${curTitle}节气海报-弹窗曝光-app`,
        from_id: 240706
      })
    },

    /**
     * 25 节气海报 记录数据到本地存储
     * @param {string} curTitle - 当前节气标题
     * @param {Date} now - 当前时间
     * @param {number} popCount - 已弹窗次数
     */
    updateSolarTermsStorage(curTitle, now, popCount) {
      localStorage.setItem(`showSolarTermsPop${curTitle}`, String(now))
      localStorage.setItem(
        `showSolarTermsPopTime${curTitle}`,
        String(popCount + 1)
      )
    },

    // ==================== 推荐教练相关方法 ====================

    /**
     * 获取推荐教练信息 优先弹日历权限的
     */
    async getRecommendCoachInfo() {
      const res = await this.$http.get(
        'member/AppEntrance?a=getAppointPreferenceFrame',
        {
          courseid: this.evaluate.courseid
        }
      )
      // res.data.code = 200
      // res.data.data = {}
      if (res.data.code === 200 && res.data.data) {
        this.recommendCoachInfo = res.data.data
        // 测试
        // this.recommendCoachInfo.coach_info = {
        //   id: 1234567890,
        //   shop_name: '测试门店',
        //   image: 'https://cdnvue.gymcity.com.cn/uploads/ykcg-zysx-tjphjl',
        //   name: '测试教练'
        // }
        // this.recommendCoachInfo.is_show = true
        //
        if (this.recommendCoachInfo.is_show) {
          // 上报推荐教练弹窗曝光
          this.$http.get('member/index?a=shareLogPush', {
            from: `约课成功页添加偏好教练—曝光`,
            from_id: 25110359
          })
          this.showPop('showRecommendCoachIPop')
        }
      }
    },

    /**
     * 推荐教练弹窗关闭处理
     * @param {Object} payload - 关闭参数
     * @param {string} payload.type - 操作类型: 'add' 添加, 'close' 不添加
     * @param {boolean} payload.checked - 是否不再提醒
     * @param {number} payload.coachId - 教练ID
     */
    async handleRecommendCoachPopClose(payload) {
      const { type, checked, coachId } = payload

      // 上报埋点
      this.$http.get('member/index?a=shareLogPush', {
        from: `约课成功页添加偏好教练—${type == 'add' ? '添加' : '不添加'}`,
        from_id: 25110359
      })

      // 关闭弹窗
      this.handlePopClose('showRecommendCoachIPop')

      // 调用接口添加偏好教练
      const res = await this.$http.get(
        'member/AppEntrance?a=addCoachPreference',
        {
          type: type == 'add' ? 1 : 0,
          cid: coachId,
          no_more_reminders: checked ? 1 : 0
        }
      )

      // 添加成功提示
      if (res.data.code === 200 && res.data.data && type == 'add') {
        this.$toast.success('已添加到偏好教练')
      }
    },

    // ==================== 导航跳转相关方法 ====================

    /**
     * 跳转教练企微名片
     */
    handleContactCoach() {
      // 上报埋点
      this.$http.get('member/index?a=shareLogPush', {
        from: `约课成功页联系教练—点击`,
        from_id: 25110359
      })
      this.$router.push(`/coach-wxwork-card?cid=${this.evaluate.coachid}`)
    },

    /**
     * 跳转课程训练计划
     */
    handleViewCourseDetail() {
      // 上报埋点
      this.$http.get('member/index?a=shareLogPush', {
        from: `约课成功页查看训练计划—点击`,
        from_id: 25110359
      })
      // 当前课程训练计划
      this.$router.push(
        `/course-plan-show?uid=${this.user.uid}&courseid=${
          this.evaluate.courseid
        }&pid=${this.recommendCoachInfo.pid || ''}`
      )
      // 跳转扫码上课
      // this.$router.push(`/scancode?mid=${this.recommendCoachInfo.mid}`)
    },

    /**
     * 打开地图导航
     */
    handleOpenMap() {
      this.$betterwe.jumpRoute(
        `/mapLauncher?latitude=${parseFloat(
          this.evaluate.lat
        )}&longitude=${parseFloat(this.evaluate.lon)}&title=${
          this.evaluate.shop_name
        }`
      )
    },

    /**
     * 继续约课
     */
    handleContinue() {
      this.$http.appBack()
    },

    /**
     * 返回App首页
     */
    handleBackApp() {
      const date = this.evaluate.s_time.split(' ')[0]
      this.$betterwe.jumpRoute(`/home?pageTag=0&pageChildType=5&date=${date}`)
    },

    // ==================== 权限相关方法 ====================

    /**
     * 去开启通知权限
     */
    handleClickBar() {
      // 上报埋点
      this.$http.get('member/index?a=shareLogPush', {
        from: `约课成功页打开消息通知—点击`,
        from_id: 25110359
      })
      this.$betterwe.addOpenPermission()
    },

    // ==================== 日历相关方法 ====================

    /**
     * 课程预约完成 上报日期，验证日历、通知权限
     * @return {void}
     */
    async addGymCourseAppointmentComplete() {
      try {
        // 获取App版本号
        const version = await this.$betterwe.getAppVersion().catch(() => {})
        console.log('保存日程version', version)

        // 获取日历事件数据
        const calendarData = await this.getCalendarEventData(version)
        console.log('保存日程参数', calendarData)

        // 调用原生方法添加日历事件
        const res = await this.$betterwe.addGymCourseAppointmentComplete(
          calendarData,
          version >= CALENDAR_CONFIG.VERSION_THRESHOLD
            ? 'createOrUpdateGymCourseCalendarEvent'
            : 'createOrUpdateCalendarEvent'
        )

        // 如果添加成功，显示通知权限悬浮按钮
        if (res && res == 1) {
          // 增加回调函数，用于接收通知悬浮按钮隐藏事件
          window['addCloseNotificationPermission'] = (res) => {
            console.log('通知悬浮按钮隐藏', res)
            if (res && res == 1) {
              this.showFloatBar = false
            }
          }
          // 显示通知权限悬浮按钮
          this.showFloatBar = true
          // 上报通知权限悬浮按钮曝光
          this.$http.get('member/index?a=shareLogPush', {
            from: `约课成功页打开消息通知—曝光`,
            from_id: 25110359
          })
        }
      } catch (error) {
        console.error('添加日历日程失败:', error)
      }
    },

    /**
     * 获取日历事件数据
     * 根据App版本返回不同的日历配置
     * @param {number} version - App版本号
     * @returns {object} 日历事件数据
     */
    async getCalendarEventData(version) {
      const { s_time, e_time, shop_name } = this.evaluate
      const timeDescription = `您的健萌私教课将在${s_time.slice(
        -8,
        -3
      )}开始，场馆为${shop_name}`

      // 新版本(>=270)使用iCloud日历
      if (version >= CALENDAR_CONFIG.VERSION_THRESHOLD) {
        return {
          calendarAccountName: CALENDAR_CONFIG.NEW_VERSION.calendarAccountName,
          calendarId: CALENDAR_CONFIG.NEW_VERSION.calendarId,
          calendarName: CALENDAR_CONFIG.NEW_VERSION.calendarName,
          eventId: '',
          description: timeDescription,
          eventTitle: CALENDAR_CONFIG.NEW_VERSION.eventTitle,
          url: '',
          allDay: CALENDAR_CONFIG.COMMON.allDay,
          availability: CALENDAR_CONFIG.COMMON.availability,
          recurrenceInterval: CALENDAR_CONFIG.COMMON.recurrenceInterval,
          recurrenceMethod: CALENDAR_CONFIG.COMMON.recurrenceMethod,
          remindersTimeMinutes: CALENDAR_CONFIG.COMMON.remindersTimeMinutes,
          startTime: s_time,
          endTime: e_time
        }
      } else {
        // 旧版本使用betterWE星球日历
        const { courseid } = this.evaluate
        return {
          calendarAccountName: CALENDAR_CONFIG.OLD_VERSION.calendarAccountName,
          calendarId: courseid,
          calendarName: this._formatTime(s_time, e_time),
          eventId: '',
          description: timeDescription,
          eventTitle: CALENDAR_CONFIG.OLD_VERSION.eventTitle,
          url: '',
          allDay: CALENDAR_CONFIG.COMMON.allDay,
          availability: CALENDAR_CONFIG.COMMON.availability,
          recurrenceInterval: CALENDAR_CONFIG.COMMON.recurrenceInterval,
          recurrenceMethod: CALENDAR_CONFIG.COMMON.recurrenceMethod,
          remindersTimeMinutes: CALENDAR_CONFIG.COMMON.remindersTimeMinutes,
          startTime: s_time,
          endTime: e_time
        }
      }
    },

    // ==================== 活动弹窗相关方法 ====================

    /**
     * 2025公众号打卡活动弹窗
     */
    checkGzhDakaPop() {
      const now = new Date().getTime()
      // 活动已结束
      if (now >= new Date('2025/02/15').getTime()) return

      const lastPopTime = localStorage.getItem('showActGzhDakaPop')
      const popCount = Number(
        localStorage.getItem('showActGzhDakaPopTime') || 0
      )

      if (this.shouldShowGzhDakaPop(lastPopTime, popCount, now)) {
        this.showgzhDakaPop = true
        this.updateGzhDakaStorage(now, popCount)
      }
    },

    /**
     * 判断是否应该显示公众号打卡弹窗
     * @param {string|null} lastPopTime - 上次弹窗时间
     * @param {number} popCount - 已弹窗次数
     * @param {number} now - 当前时间戳
     * @returns {boolean}
     */
    shouldShowGzhDakaPop(lastPopTime, popCount, now) {
      return (
        !lastPopTime ||
        (popCount < 99 &&
          new Date(now).toDateString() !==
            new Date(lastPopTime * 1).toDateString())
      )
    },

    /**
     * 更新公众号打卡弹窗存储数据
     * @param {number} now - 当前时间戳
     * @param {number} popCount - 已弹窗次数
     */
    updateGzhDakaStorage(now, popCount) {
      localStorage.setItem('showActGzhDakaPop', String(now))
      localStorage.setItem('showActGzhDakaPopTime', String(popCount + 1))
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.reservations {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
  padding-bottom: vw(90);
  padding-bottom: calc(
    #{vw(90)} + constant(safe-area-inset-bottom)
  ); //兼容 IOS<11.2
  padding-bottom: calc(#{vw(90)} + env(safe-area-inset-bottom)); //兼容 IOS>11.2
  .reservations-bar {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 66;
    color: #fff;
    font-weight: 600;
    .bar-back {
      position: absolute;
      left: vw(20);
    }
    .icon-you {
      display: block;
      font-size: 24px;
      transform: rotate(180deg);
    }
    .bar-logo {
      width: vw(218);
    }
  }
  .new-top-bg {
    width: 100%;
    box-sizing: border-box;
    height: 360px;
    background: linear-gradient(
      180deg,
      #ff2270 0%,
      #fc3078 50%,
      #f55f95 60%,
      rgba(220, 0, 80, 0) 100%
    );
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .new-top-top {
    width: 100%;
    // height: vw(220);
    // background: linear-gradient(180deg, #ff2270 0%, #dc0050 100%);
    // background: url('https://cdnvue.gymcity.com.cn/uploads/yueke-unit-bg') 0 0 /
    //   100% auto repeat-y;
    // position: absolute;
    // top: 0
    margin-top: vw(30);
    margin-bottom: vw(20);
    .top-img-box {
      display: flex;
      align-items: center;
      justify-content: center;
      .top-img {
        width: vw(32);
        margin-right: vw(10);
      }
      .top-text {
        font-size: vw(24);
        line-height: vw(32);
        font-weight: 600;
        color: #fff;
      }
    }
  }
  .new-complete-bar {
    width: vw(355);
    height: vw(48);
    box-sizing: border-box;
    padding: vw(10);
    padding-left: vw(20);
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0 vw(2) vw(4) 0 rgba(0, 0, 0, 0.04);
    border-radius: vw(8);
    font-weight: 500;
    font-size: vw(15);
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: vw(10);
    .bar-right {
      width: vw(64);
      height: vw(28);
      background: rgba($color: #ff2270, $alpha: 0.1);
      border-radius: vw(14);
      font-weight: 500;
      font-size: vw(13);
      color: #ff2270;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .new-top-content {
    width: vw(355);
    box-sizing: border-box;
    background-color: #fff;
    color: #000;
    border-radius: vw(8);
    padding: vw(10);
    padding-top: vw(20);
    box-shadow: 0px vw(2) vw(4) 0px rgba(0, 0, 0, 0.05);
    position: relative;
    overflow: hidden;
    &.new-top-content-grade {
      padding-top: vw(50);
    }
    .rs-top-grade {
      width: vw(357);
      box-sizing: border-box;
      position: absolute;
      top: -1px;
      left: -1px;
    }
    .rs-top-item {
      width: 100%;
      box-sizing: border-box;
      padding-left: vw(10);
      margin-bottom: vw(20);
      display: flex;
      .item-title {
        color: rgba(0, 0, 0, 0.5);
        font-size: vw(15);
        margin-right: vw(20);
      }
      .item-content {
        .item-text {
          color: #050b27;
          font-size: vw(15);
          font-weight: 500;
          display: flex;
          align-items: center;
          .location-icon {
            font-size: vw(16);
            color: #dc0050;
            width: vw(12);
            margin-left: vw(4);
          }
        }
        .item-tips {
          color: rgba($color: #050b27, $alpha: 0.8);
          font-size: vw(12);
          font-weight: 300;
          margin-top: vw(3);
        }
      }
    }
    .rs-bottom {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .rs-bottom-item {
        width: vw(165);
        height: vw(36);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f7f7f7;
        border-radius: vw(6);
        border: 1px solid #f1f1f1;
        font-weight: 400;
        font-size: vw(14);
        color: rgba(0, 0, 0, 0.8);
        .item-btn-icon {
          color: #050b27;
          font-size: vw(18);
          width: vw(18);
          margin-right: vw(10);
        }
      }
    }
  }
  .atend-img {
    width: vw(355);
    box-sizing: border-box;
    display: block;
    margin-top: vw(20);
  }
  .rs-btn-box {
    width: vw(355);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: vw(20);
    bottom: calc(#{vw(20)} + constant(safe-area-inset-bottom));
    bottom: calc(#{vw(20)} + env(safe-area-inset-bottom));
    z-index: 9;
    .rs-btn-back {
      width: vw(132);
      height: vw(48);
      box-sizing: border-box;
      background: #ffffff;
      border-radius: vw(24);
      font-weight: 500;
      font-size: vw(16);
      color: #000000;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: vw(8);
    }
    .rs-btn {
      flex: 1;
      height: vw(48);
      box-sizing: border-box;
      background-color: #ff2270;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: vw(99);
      color: #fff;
      font-size: vw(16);
      font-weight: 500;
    }
  }
}
</style>
